import _ from 'underscore';

const campaignTypeEnum = {
  1: 'search',
  2: 'shopping',
  4: 'dynamicSearch',
  8: 'audience',
  Default: 'search',
  Shopping: 'shopping',
  DynamicSearchAds: 'dynamicSearch',
  Audience: 'audience',
};

export function getCampaignType(campaign) {
  const rawType = _.result(campaign, 'CampaignType');

  return _.result(campaignTypeEnum, rawType, rawType);
}
